import styled from 'styled-components'
import playImg from '../../assets/play.png'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import slide1Img from '../../assets/slide1.png'
import { chunk } from '../../utils/util'
import { useEffect, useState,useRef } from 'react'
import PopUp2Mobile from "../../components/PopUp2Mobile";

function Page4Mobile(prop) {
  const slickRef = useRef(null)
  var settings = {
    dots: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => (
      <div
        style={{
          height: '100px',
          display: 'flex',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <ul
          style={{
            margin: '0',
            padding: '0',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          cursor: 'pointer',
          width: '8px',
          height: '8px',
          borderRadius: '8px',
          border: '0.7px solid #f7f7f7',
        }}
      ></div>
    ),
  };
  
  const [showPopUpUrl, setShowPopUp] = useState(null);
  const close = () => {
    setShowPopUp(null);
  };

  const items = prop.items
  const itemId = prop.itemId
  const [selectedItem, setSelectedItem] = useState()

  const [subItemList, setSubItemList] = useState([])
  const [selectedSubItem, setSelectedSubItem] = useState()
  const [chunkSubItemList, setChunkSubItemList] = useState([])
  const [subItemFileList, setSubItemFileList] = useState()

  useEffect(() => {
    let index = ''
    if (items && itemId) {
      debugger
      index = items.findIndex((el) => {
        return el.itemSeq == itemId
      })
    }
    setSelectedItem(items[index])
    setSubItemList(items[index]?.subItemDtoList)
    setSelectedSubItem(items[index]?.subItemDtoList[0])
  }, [items, itemId])

  useEffect(() => {
    setSubItemList(selectedItem?.subItemDtoList)
    setSelectedSubItem(selectedItem?.subItemDtoList[0])
  }, [selectedItem])

  useEffect(() => {
    setChunkSubItemList(chunk(selectedItem?.subItemDtoList, 6))
  }, [subItemList])

  useEffect(() => {
    debugger
    console.log(selectedSubItem)
    setSubItemFileList(selectedSubItem?.fileDtoList)
    setTimeout(()=>{ slickRef.current?.slickGoTo(0, true);}, 100);
  }, [selectedSubItem])


	const [moved, setMoved] = useState(false);
	const downListener = () => {
		setMoved(false);
  }
	const moveListener = () => {
  	setMoved(true);
	}
  const upListener = (url, idx) => {
    console.log(url);
    if (moved) {
        console.log('moved')
    } else {
        console.log('not moved');
        setShowPopUp(url);
    }
  }
  return (
    <>
    {showPopUpUrl ? <PopUp2Mobile img={showPopUpUrl} close={close} /> : null}
    <MainContainer>
      <Top>
        {items &&
          selectedItem &&
          items.map((item) => {
            return (
              <TopText
                selected={selectedItem.itemSeq == item.itemSeq}
                key={item.itemSeq}
                onClick={() => {
                  setSelectedItem(item)
                }}
              >
                {item.itemName}
              </TopText>
            )
          })}
      </Top>
      <CustomSlider ref={slickRef}
      {...settings}>
        {subItemFileList &&
          subItemFileList.map((file, idx) => {
            if (file.fileType == 'IMAGE') {
              return (
                <Slide1
                  key={idx}
                  src={process.env.REACT_APP_BASE_RESOURCES_API + file.filePath}
                
                  onMouseUp={() => upListener(process.env.REACT_APP_BASE_RESOURCES_API + file.filePath, idx)}
                  onMouseMove={moveListener}
                  onMouseDown={downListener}
                />
              )
            }else{
              return (
                <SlideV>
                  <Slide2
                    controls
                    key={idx}
                    src={process.env.REACT_APP_BASE_RESOURCES_API + file.filePath}
                  />
                </SlideV>
              )

            }
          })}
      </CustomSlider>
      <Middle>
        <TextsContainer>
          {selectedSubItem && (
            <>
              <Text1>{selectedSubItem.siKorName}</Text1>
              <Text2>{selectedSubItem.siEngName}</Text2>
            </>
          )}
        </TextsContainer>
        <BoxesContainer>
          {chunkSubItemList &&
            selectedSubItem &&
            chunkSubItemList.map((i, idx) => {
              return (
                <Row key={idx}>
                  {i.map((j) => {
                    return (
                      <OutLine
                        key={j.siSeq}
                        selected={selectedSubItem.siSeq == j.siSeq}
                        onClick={() => {
                          setSelectedSubItem(j)
                        }}
                      >
                        <InnerBox 
                          src={j?.siFileDto!=null?process.env.REACT_APP_BASE_RESOURCES_API + j?.siFileDto?.filePath:null}
                          />
                      </OutLine>
                    )
                  })}
                </Row>
              )
            })}
        </BoxesContainer>
      </Middle>
      {selectedItem &&
        selectedItem.itemFileDto &&
        (selectedItem.itemFileDto.fileType == 'IMAGE' ? (
          <Img
            src={
              process.env.REACT_APP_BASE_RESOURCES_API +
              selectedItem.itemFileDto.filePath
            }
          />
        ) : (
          <Video
            controls
            playsInline
            autoPlay
            muted
            src={
              process.env.REACT_APP_BASE_RESOURCES_API +
              selectedItem.itemFileDto.filePath
            }
          />
        ))}
      {selectedItem &&
        selectedItem.itemSubFileDto &&
        (selectedItem.itemSubFileDto.fileType == 'IMAGE' ? (
          <Img
            src={
              process.env.REACT_APP_BASE_RESOURCES_API +
              selectedItem.itemSubFileDto.filePath
            }
          />
        ) : (
          <Video
            controls
            playsInline
            autoPlay
            muted
            src={
              process.env.REACT_APP_BASE_RESOURCES_API +
              selectedItem.itemSubFileDto.filePath
            }
          />
        ))}
    </MainContainer>
    </>
  )
}

export default Page4Mobile
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 66px;
  width: 100vw;
  overflow-x: hidden;
  padding-bottom: 60.7px;
`
const Video = styled.video`
  width: 100vw;
  height: 211px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
`
const Img = styled.img`
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
`

const Play = styled.img`
  width: 73px;
  height: 73px;
`
const Top = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  height: 44.3px;
  background: #1f1f1b;
  overflow-x: scroll;
  padding: 0px 20px;
  gap: 25px;

  //margin: 0 auto;
  //justify-content: center;

`
const TopText = styled.p`
  flex: 0 0 auto;
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 13.3px;
  color: ${(props) => (props.selected ? '#ae9c75' : '#848484')};
`
const CustomSlider = styled(Slider)`
  height: 375px;
  overflow: hidden;
`
const Slide1 = styled.img`
  height: 375px;
  object-fit: cover;
`
const SlideV = styled.div`
  height: 375px;
  overflow-y:hidden;
  text-align: center;
  background: black;
  display:flex!important;
`
const Slide2 = styled.video`
  object-fit: contain;
`

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
`
const TextsContainer = styled.div`
  width: 310px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  margin-top: 25.8px;
`
const Text1 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 21.7px;
  color: #000;
`
const Text2 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  font-size: 12.3px;
  color: #b4b4b4;
  margin-bottom: 3px;
`
const BoxesContainer = styled.div`
  width: 310px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 21.2px;
  margin-bottom: 31px;
`
const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px 15px;
  justify-content: flex-start;
`
const OutLine = styled.div`
  border: ${(props) =>
    props.selected ? '1px solid #2e2e2e' : '0.3px solid #a0a0a0'};
  width: 36.3px;
  height: 36.3px;
  margin-bottom:10px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const InnerBox = styled.img`
  width: 29.7px;
  height: 29.7px;
  background: gray;
`
